<app-resp-popup-title>
  <span i18n="@@WawiApiNoteFacilityUpdateDialog_Title"
    >Edit facility note</span
    >
  </app-resp-popup-title>
  <app-resp-popup-content>
    <div class="content">
      @if (!loading) {
        <app-wawi-note-facility-update-form
          [form]="form"
        ></app-wawi-note-facility-update-form>
      } @else {
        <div style="position: relative; width: 100%; height: 400px">
          <app-shimmer [isLoading]="loading" type="form-small"></app-shimmer>
        </div>
      }
    </div>
  </app-resp-popup-content>
  @if (!loading) {
    <app-resp-popup-actions>
      @if (form) {
        <ctrl-btn-accept
          [disabled]="!form.valid"
          (click)="OnAccept()"
        ></ctrl-btn-accept>
      }
      <ctrl-btn-cancel (click)="OnCancel()"></ctrl-btn-cancel>
    </app-resp-popup-actions>
  }

